import { render, staticRenderFns } from "./ModalInsercaoArquivoVetorial.vue?vue&type=template&id=c8c4a23c&lang=pug"
import script from "./ModalInsercaoArquivoVetorial.vue?vue&type=script&lang=js"
export * from "./ModalInsercaoArquivoVetorial.vue?vue&type=script&lang=js"
import style0 from "./ModalInsercaoArquivoVetorial.vue?vue&type=style&index=0&id=c8c4a23c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports